// Module
var code = "<div class=\"mcb-toast mcb-toast--{{hPos}} mcb-toast--{{vPos}} {{ animation ? 'mcb-toast--animate-' + animation : '' }}\"> <div class=\"mcb-toast__list\"> <mcb-toast-message ng-repeat=\"message in messages\" message=\"message\" count=\"message.count\"> <span ng-bind-html=\"message.content\"></span> </mcb-toast-message> </div> </div> ";
// Exports
module.exports = code;